import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MatCheckboxChange, MatDialog } from '@angular/material';
import { OrderInsertResponseComponent } from '../order-insert-response/order-insert-response.component';
import Swal from 'sweetalert2';
import { OrderService } from 'src/app/services/order.service';
import { Account } from 'src/app/models/account.model';
import { OrderInsertRequest } from 'src/app/models/virtual-store/order-insert-request.model';
import { Subject, Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MasterService } from 'src/app/services/master.service';
import { HtmlPolicy } from 'src/app/models/master/html-policy.model';
import { AccountService } from 'src/app/services/account.service';
import { Despacho } from 'src/app/models/virtual-store/despacho.model';
import { filter, takeUntil } from 'rxjs/operators';
import { OrderItemService } from 'src/app/services/order-item.service';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { DetailedOrderItem } from 'src/app/models/virtual-store/detailed-order-item.model';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';
import { OrderInsertResponse } from 'src/app/models/virtual-store/order-insert-response.model';
import { GoogleAnalyticsData } from 'src/app/models/virtual-store/google-analytics-data.model';
import { SharedServiceOrderObservable } from '../shared-services/shared-service-order';
import { FinanciamientoDetalleOFV, OrdenImpresionRequest, TipoDocumentos } from 'src/app/models/virtual-store/order-Impresion';
import { TiendaVirtualClauseAccepted } from 'src/app/data-transfer/tienda-virtual-accepted';

declare var fbq: Function;
declare var gtag: Function;
declare var gtag2: Function;

declare var fbq2: Function;

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {
  @Input() fullName: string = '';
  clauseAccepted: boolean = false;
  account: Account;
  policy = new HtmlPolicy();
  despacho = new Despacho();
  despachoSubscription: Subscription
 
  
  unsubscribeConditionAccepted:Subscription;
  /**Subscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  unsubscribe$ = new Subject();
  itemsOrder: DetailedOrderItem[] = [];
  creditLineFNB: CreditLineFNB = new CreditLineFNB();
  totalAmount: number = 0;
  _conditionAccepted = null;
  tipoDocumentos : TipoDocumentos[]  = [{Nombre :'Ver Hoja de Resumen' , Valor:0 , NombreDocumento : "Hoja De Resumen"} ,{Nombre :'Ver Contrato' , Valor:1 , NombreDocumento : "Contrato" } , {Nombre :'Ver Cronograma' , Valor:2 , NombreDocumento : "Cronograma"} ];
 

  private subscription: Subscription;

  constructor(
    
    private tiendaVirtualClauseAccepted: TiendaVirtualClauseAccepted,
    public dialog: MatDialog, private orderService: OrderService,
    private commonService: CommonService,
    private authService: AuthService,
    private accountService: AccountService,
    private masterService: MasterService,
    private orderItemService: OrderItemService,
    private virtualStoreService: VirtualStoreService) {
    this.creditLineFNB = this.authService.getCreditLineFNB();
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.account = account;
    })
    this.despachoSubscription = this.commonService.ActivateDelyveri.subscribe(despacho => {
      this.despacho = despacho;
    });

    this.unsubscribeConditionAccepted =this.tiendaVirtualClauseAccepted.obtenerMensaje().subscribe((conditionAccepted)=>{
      this._conditionAccepted=conditionAccepted;
       
    })
  }
 
  ngOnInit() {
    this.getPolicy();
 
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.subscription.unsubscribe();  
    this.unsubscribeConditionAccepted.unsubscribe();
  }

  openDialog(operationNumber: string) {
    this.dialog.open(OrderInsertResponseComponent, {
      disableClose: true,
      data: {
        operationNumber: operationNumber,
        totalAmount: this.totalAmount
      }
    });
  }
  downLoadFile(data: any, type: string) {

    const blob = new Blob([data], { type: type.toString() });
    const url = window.URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');

    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }

  downloadFilePDF(data: any, fileName: string): void {
    const blob = new Blob([data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const downloadLink =document.createElement('a');
    downloadLink.href=url ;
    downloadLink.setAttribute('download',fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  
  verContrato(TipoDocumento : number) {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let datosImpresion = new OrdenImpresionRequest ();
    this.virtualStoreService.orderUpdatedAnnounced.subscribe(orderItemList => {
    this.itemsOrder = orderItemList;
    });
    let detallePedido : FinanciamientoDetalleOFV[];
        detallePedido = this.itemsOrder.map(d => 
          { 
          return {
                  IdProducto: d.id,
                  CantidadProducto:d.count,
                  PrecioProducto : d.product.price,
                  IdAliadoComercial :d.product.aliadoComercialFnbId,
                  NombreProducto : d.product.description
                 }
          })  as FinanciamientoDetalleOFV[];
    let total  = this.itemsOrder.map(n=>n.product.price).reduce((sum,item)=>sum+item,0);
        datosImpresion.Dni = localStorage.getItem("dni");;
        datosImpresion.NroContratoFinanciero = "c";
        datosImpresion.Cliente = this.authService.getUser().fullName;;
        datosImpresion.Correo = this.despacho.clientEmail;
        datosImpresion.Sede = "";
        datosImpresion.FinanciamientoId = "";
        datosImpresion.FechaVenta = new Date();
        datosImpresion.DireccionCliente = "";
        datosImpresion.NroBoleta = "";
        datosImpresion.RepresentanteNombre = null;
        datosImpresion.RepresentanteDni = null;
        datosImpresion.RepresentanteParentezco = null;
        datosImpresion.Horario =4;
        datosImpresion.Referencia = this.despacho.referenciaDespacho;
        datosImpresion.SedeRecojo = null;
        datosImpresion.FechaRecojo = this.despacho.fechaEnvio;
        datosImpresion.Productos =detallePedido;
        datosImpresion.Consentimiento = false;
        datosImpresion.NroCuota =parseInt(localStorage.getItem('nroCuotas'));// por calcular
        datosImpresion.TipoReporte=TipoDocumento;
    this.orderService.ContratoFNB(datosImpresion).subscribe(blobFile => {
      // if (isIEOrEdge) {
      //   window.open(blobFile, '_blank');
      // } else {
      //   this.downLoadFile(blobFile, 'application/pdf');
      // }
      this.downloadFilePDF(blobFile,this.tipoDocumentos.find(x=>x.Valor===TipoDocumento).NombreDocumento);
    });
  }
  save() {
    this.updateTotalAmount();
    if (this.clauseAccepted) {
      let order = new OrderInsertRequest();
      const basicData = this.accountService.getStorageBasicData();
      order.channel = "OFI";
      order.clientCode = this.account.clientCode;
      order.fullName = this.fullName;
      order.emailAddress = this.authService.getUser().emailAddress;
      order.conditionAccepted = this._conditionAccepted;
      order.clauseAccepted = this.clauseAccepted;
      if (basicData.creditLineFNB.isCreditLineFNB) {
        order.emailAddress = this.despacho.clientEmail;
        order.documentType = basicData.documentType;
        order.documentNumber = basicData.documentNumber;
        order.despacho = this.despacho;
        this.orderService.addFNB(order).subscribe(response => {
          if (response.valid) {
            this.openDialog(response.data.numeroVenta);
            this.updateListPneding(this.account.clientCode, true)
            this.getBasicDataRequired(this.account.clientCode);
            fbq('track', 'Purchase', {});
            gtag('event', 'conversion', { 'send_to': 'AW-11084559693/_7GfCP-upIsYEM3qw6Up', 'transaction_id': '' });

            this.googleAnlyticsPurchase(response.data.googleAnalytics)
            this.facebookPixelPurchase(response.data.googleAnalytics);
          }
        });
      }
      else {
        this.orderService.add(order).subscribe(response => {
          if (response.valid) {
            this.openDialog(response.data);
            this.updateListPneding(this.account.clientCode, false)
            this.getBasicDataRequired(this.account.clientCode);
            fbq('track', 'Purchase', {});
            gtag('event', 'conversion', { 'send_to': 'AW-11084559693/_7GfCP-upIsYEM3qw6Up', 'transaction_id': '' });
          }
        });
      }
    } else {
      Swal.fire('Validación', 'Debe aceptar las claúsulas de contratación.', 'warning');
    }

  }
  async getPolicy() {
    let request: any = {};
    if (this.creditLineFNB.isCreditLineFNB) {
      request = await this.masterService.getHtmlPolicy("CLAUSULA_CONTRATACION_TV_FNB").toPromise();
    } else {
      request = await this.masterService.getHtmlPolicy("CLAUSULA_CONTRATACION_TV").toPromise();
    }

    if (request.valid) this.policy = request.data;
  }

  getBasicDataRequired(clientCode: string) {
    this.accountService.getBasicDataRequired(clientCode)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        if (response.valid) {
          this.commonService.announceAccountDataFetched(response.data);
        }
      });
  }
  updateListPneding(clientCode: string, isFnb: boolean) {
    this.orderItemService.listPendingOnes(clientCode, isFnb)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        this.itemsOrder = response.data;
        this.virtualStoreService.announceOrderUpdated(this.itemsOrder);
      });
  }

  updateTotalAmount() {
    this.totalAmount = 0;
    if (this.itemsOrder != null && this.itemsOrder.length > 0) {
      this.totalAmount = this.itemsOrder.map(x => (x.product.price - x.product.ofvDiscount) * x.count).reduce((previous, current) => {
        return previous + current;
      });
    }
  }

  googleAnlyticsPurchase(googleModel: any) {

    gtag2('event', 'purchase', googleModel)
  }


  facebookPixelPurchase(productos: GoogleAnalyticsData) {


    var contentsToFb = productos.items.map((item, index) => {
      return {
        id: item.item_id,
        quantity: item.quantity,
        item_price: item.price,
        name: item.item_name,
      }
    })
    fbq2('track', 'Purchase', {
      value: productos.value,  // Precio total de la compra
      currency: 'PEN',  // Tipo de moneda
      content_type: productos.items[0].item_brand,  // Tipo de contenido (puedes personalizar según tu caso)
      contents: contentsToFb
    }); 
  }
}


